import './index.css'
import cn from 'clsx'

import React from 'react'
import BlockDropWrapper from 'containers/dnd/campaign-editor/block-drop-wrapper'
type Props = {
  type: 'section' | 'content'
  campaignId: string
  sectionIndex: number
  columnIndex?: number
  contentIndex?: number
  wrapperClassName?: string
}

const InsertPoint = ({
  type,
  campaignId,
  sectionIndex,
  columnIndex,
  contentIndex,
  wrapperClassName,
}: Props): React.ReactNode => (
  <BlockDropWrapper
    type={type}
    campaignId={campaignId}
    sectionIndex={sectionIndex}
    columnIndex={columnIndex}
    contentIndex={contentIndex}
  >
    <div className={cn('content-editor__insert-point', wrapperClassName)}>
      <div className="content-editor__insert-point__devider" />
      <div className="content-editor__insert-point__devider__text">
        + Insert here
      </div>
    </div>
  </BlockDropWrapper>
)

export default InsertPoint
